import { render, staticRenderFns } from "./SelectDetail.vue?vue&type=template&id=13b47baa&scoped=true"
import script from "./SelectDetail.vue?vue&type=script&lang=js"
export * from "./SelectDetail.vue?vue&type=script&lang=js"
import style0 from "./SelectDetail.vue?vue&type=style&index=0&id=13b47baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b47baa",
  null
  
)

export default component.exports